import { Component } from 'react'
import { createPositionInterest, deletePositionInterest, listPositionInterests, updatePositionInterest } from '../../../../../../insfrastructure/services/job-title-interests'
import { ErrorMessage, emptyField, errorsLength, formatErrors } from '../../../../../../insfrastructure/utils/form-validators'
import { generateKey } from '../../../../../../insfrastructure/utils/array-key'
import { listJobTitles } from '../../../../../../insfrastructure/services/jobs'
import ConfirmationModal from '../../../../../components/confimation-modal'
import { SubmitBtn } from '../../../../../components/submit'
import { Select } from '../../../../../components/select'
import './styles.sass'

export default class JobTitleInterestsForm extends Component {
  state: any = {
    experience_items: [],
    all_jobtitles_options: []
  }

  componentDidMount() {
    this.listJobTitles();
    this.listExpirences();
  }

  listExpirences = async () => {
    try {
      const response = await listPositionInterests(localStorage.getItem('candidate_id'));

      const experience_items = response.results.map(item => {    
        return {
          item,
          editing: false
        };
      });

      this.setState({ experience_items });
    } catch (error) {}
  }

  listJobTitles = async () => {
    const items = (await listJobTitles()).map(x => ({ value: parseInt(x.id), label: x.name }));

    this.setState({ all_jobtitles_options: items });
  }

  editExperience = (id: number) => {
    const items = [...this.state.experience_items].map(x => {
      if(x.item.id === id) {
        x.editing = true;
      };
    
      return x;
    });

    this.setState({ experience_items: items });
  }

  addExperience = () => {
    const items = [...this.state.experience_items];
    items.push({
      item: {
        id: 0
      },
      editing: true
    });

    this.setState({ experience_items: items });
  }

  onSubmitExperience = async (x: any, index: number) => {
    console.log(x);
    
    const newItem = x.id === 0 ? await createPositionInterest(x) : await updatePositionInterest(x.id, x);

    const items = [...this.state.experience_items].map(y => {
      if(y.item.id === x.id) {
        y.item = newItem;
        y.editing = false;
      };
    
      return y;
    });

    let responseData = {
      type: 'success',
      title: 'Dados salvos com sucesso!',
      text: () => <></>
    };

    setTimeout(() => {
      this.setState({ loading: false, experience_items: items, responseData });
    });
  }

  removeExperience = async (id: number) => {
    try {
      await deletePositionInterest(id);

      const items = this.state.experience_items.filter((x: any) => x.item.id !== id);

      let responseData = {
        type: 'success',
        title: 'Cargo de Interesse removido com sucesso!',
        text: () => <></>
      };

      setTimeout(() => {
        this.setState({ loading: false, experience_items: items, responseData });
      });
    } catch (error) {
      let responseData = {
        type: 'error',
        title: 'Ocorreu um erro inesperado',
        text: () => <></>
      };

      this.setState({ loading: false, responseData });
    }
  }

  render() {
    return (
      <div className='job-title-interests-form'>
        <h1>Cargos de Interesse</h1>
        <div className='job-titles'>
          {
            this.state.experience_items.length > 0 ?
            this.state.experience_items.map((x: any, i: number) =>
            <JobTitleForm
            key={generateKey('job-title_'+i)}
            all_jobtitles_options={this.state.all_jobtitles_options}
            formData={x.item}
            readonly={!x.editing}
            onSubmit={(e) => this.onSubmitExperience(e, i)}
            onUpdate={this.editExperience}
            onRemove={i => this.removeExperience(i)} />) :
            <div className='empty-list'>
              <p>Nenhuma cargo de interesse adicionado</p>
            </div>
          }
        </div>
        {this.state.experience_items.filter((item: any) => item.editing).length === 0 &&
        <SubmitBtn className='secondary' text='Adicionar Interesse de Vaga' onSubmit={this.addExperience} />}
      </div>
    )
  }
}

class JobTitleForm extends Component<{all_jobtitles_options: any[], formData: any, onSubmit: (x: any) => any, onUpdate: (x: any) => any, onRemove: (i: number) => void, readonly: boolean}> {
  state: any = {
    form: {},
    formErrors: {},
    loading: false
  }

  componentDidMount() {
    if(this.props.formData) {
      console.log(this.props.formData, this.props.all_jobtitles_options);
      
      this.setState({ form: this.props.formData });
    };
  }

  onSubmit = async () => {
    const errors = formatErrors({
      job_title_id: [emptyField(this.state.form.job_title_id, 'job_title_id')]
    });

    this.setState({ formErrors: errors });
  
    if(errorsLength(errors) > 0) return;

    this.setState({ loading: true });

    try {
        this.props.onSubmit(this.state.form);
        
        setTimeout(() => {
            this.setState({ loading: false });
        });
    } catch (error) {
        this.setState({ loading: false });
    }
  }

  onRemoveInterest = async () => {
    this.setState({ loading: true });
    this.setState({ selectedItemToDelete: null });

    try {
        setTimeout(() => {
          this.setState({ loading: false });
          this.props.onRemove(this.state.form.id as number);
        });
    } catch (error) {
        this.setState({ loading: false });
    }
  }

  render() {
    return (
      <div className='form'>
        <div className='columns-group'>
          <div className='full-width-column'>
            <Select
            name='job_title_id'
            label='Cargo Desejado'
            placeholder='Cargo Desejado'
            value={this.state.form['job_title_id']}
            options={this.props.all_jobtitles_options}
            readonly={this.props.readonly}
            onChange={e => this.setState({ form: { ...this.state.form, job_title_id: e } })}/>
            <ErrorMessage errors={this.state.formErrors['job_title_id']} />
          </div>
        </div>
        <div className='btns'>
          {!this.props.readonly &&
          <SubmitBtn className='secondary' text='Salvar Alterações' loadingText='Salvando...' loading={this.state.loading} onSubmit={this.onSubmit} />}
          {/* {this.props.readonly &&
          <SubmitBtn className='secondary' text='Editar' onSubmit={() => this.props.onUpdate(this.state.form['id'])} />} */}
          {this.props.readonly &&
          <SubmitBtn className='secondary' text='Remover' loadingText='Removendo...' loading={this.state.loading} onSubmit={() => this.setState({ selectedItemToDelete: true })} />}
        </div>
        <ConfirmationModal
        title='Deletar esse cargo de interesse?'
        text='Tem certeza que deseja deletar esse cargo de interesse? Nós não mostraremos ele novamente para você.'
        render={this.state.selectedItemToDelete}
        onConfirm={this.onRemoveInterest}
        onClose={() => this.setState({ selectedItemToDelete: null })}/>
      </div>
    )
  }
}

